import store from "@/state/store";
import type { RoomParts } from "@/collab/roomName";

export interface SectionDescriptor {
    /** Bridge docId suffix — docId is `section-<sectionId>`. */
    sectionId: string;
    /** Ydoc fragment field is `sectionField(warehouseId)` = `section-<warehouseId>`. NOT the same id space. */
    warehouseId: number | string;
    title: string;
    /** Last-loaded HTML, used to seed an un-seeded fragment. */
    contentHtml: string;
}

export function currentRoomParts(): RoomParts | null {
    const s = store.getState().workProductDocuments;
    if (s.status !== "succeeded" || !s.activeContext || s.activeVersion == null) return null;
    return {
        projectId: s.activeContext.projectId,
        featureId: s.activeContext.featureId ?? null,
        userStoryId: s.activeContext.userStoryId ?? null,
        workProductId: s.activeContext.workProductId,
        version: s.activeVersion
    };
}

export function currentSections(): SectionDescriptor[] {
    const s = store.getState().workProductDocuments;
    return (s.documents ?? []).map(d => ({
        sectionId: String(d.section_id),
        warehouseId: d.warehouse_id,
        title: d.section_title ?? "Untitled Section",
        contentHtml: d.content ?? ""
    }));
}

export function findSectionByDocId(docId: string): SectionDescriptor | null {
    const m = /^section-(.+)$/.exec(docId);
    if (!m) return null;
    return currentSections().find(sec => sec.sectionId === m[1]) ?? null;
}
